( function( global, $ ) {

    $(document).on('click' , '[gr-scroll-to-mobile]', function(e) {
        if (global.methods.isMobile('breakpoint', 'sm')) {
            e.preventDefault();

            var element = $(this).attr('gr-scroll-to-mobile'),
                elementOffset = $(element).offset().top + 1,
                extraHeight = 150;

            $("html, body").animate({ scrollTop: elementOffset - extraHeight }, 600 );
        }
    });
}( window.groots, jQuery ));
